import {Row} from './Row'
import React, {FC, ReactNode} from 'react'
import {WebFormsDataTable, WebFormStatus} from '../../../../../app/@types'

type Props = {
    TableHead: ReactNode
    paginateData: WebFormsDataTable[]
    allStatus: WebFormStatus[]
}

const TableContent: FC<Props> = ({TableHead, paginateData, allStatus}) => {

    return (
        <div className="table-responsive">
            <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">

                {TableHead}

                <tbody>
                {
                    paginateData.map((item, index) => {

                        const formData = {
                            first_name: item.firstName || '',
                            last_name: item.lastName || '',
                            email: item.subscriber?.email || '',
                            number: item.subscriber?.telephone || '',
                            street: item.subscriber?.street || '',
                            companyName: item.subscriber?.societe || '',
                        }

                        const matchedStatus = allStatus.find(s => s.id === item.status)

                        return (
                            <Row key={index}
                                 item={item}
                                 matchedStatus={matchedStatus}
                                 index={index}
                                 formData={formData}
                            />
                        )
                    })
                }
                </tbody>
            </table>
        </div>
    )
}

export {TableContent}